export const getFileExtension = (fileName: string) =>
  fileName.split(".").pop()?.toLowerCase() || "";

export const isValidFileType = (file: File, acceptedTypes: string) => {
  const accepted = acceptedTypes.split(",").map((type) => type.trim());
  return accepted.includes(file.type);
};

export const isValidFileSize = (file: File, maxSizeMB: number) => {
  return file.size <= maxSizeMB * 1024 * 1024;
};
